<div class="row">
  <div class="col-12 mb-2">
    <div>
      <div class="row mb-2">
        <div class="col-xl-8 col-md-12">
          <div class="d-flex align-items-baseline">
            <label class="form-check-label me-2 form-label required-star" for="">
              {{ title ? title : ("common.email-addresses" | translate) }}
            </label>
            <div
              *ngIf="isSubmit && (form.controls['contacts'].errors?.['missingEmail'] || form.controls['contacts'].errors?.['required'])"
              class="required"
            >
              {{ "definition.staff.email-req" | translate }}
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-12 right-end" *ngIf="!isReadOnly">
          <button
            type="button"
            class="btn btn-sm btn-warning btn-icon-xxs ms-2"
            (click)="newHeadItem()"
          >
            <i class="fas fa-add"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-warning btn-icon-xxs ms-2"
            *ngIf="showSearchIcon"
            (click)="onClickSearchIcon()"
          >
            <i class="fas fa-search"></i>
          </button>
          <span *ngIf="showSearchIcon && (patientEmails ?? 0) > 0" class="custom-badge">
            {{patientEmails}}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 mb-2" *ngIf="newEmailItem">
    <div class="card p-3 mb-2">
      <div class="row mb-2 text-center">
        <div class="col-xl-3">
          <p-dropdown
            [options]="types"
            placeholder="{{ 'general.title' | translate }}"
            [(ngModel)]="newEmailData.type"
            optionLabel="label"
            appendTo="body"
          >
          </p-dropdown>
        </div>
        <div class="col-xl-5">
          <input
           #emailInput
            type="email"
            class="form-control form-control-sm"
            [(ngModel)]="newEmailData.email"
            placeholder="{{ 'shared-components.email-plc' | translate }}"
            required
          />
        </div>
        <div class="col-xl-2">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            [(ngModel)]="newEmailData.priority"
            aria-checked="true"
          />
        </div>
        <div class="col-xl-2">
          <button
          class="btn btn-sm btn-primary float-right"
          (click)="add()"
          [disabled]="!isAddValid()"
        >
          {{ "general.add" | translate }}
        </button>
        </div>
      </div>
    </div>
  </div>


  <div class="col-12"  *ngFor="let item of emailItems; let i = index; trackBy: trackByFn">

    <div class="card p-3 border mb-2" style="  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);" *ngIf="editingIndex !== i; else editingRow">
      <div class="row mb-2 text-center">
        <div class="col-xl-1">
          <i
            class="fa fa-star"
            [ngStyle]="{ color: item?.priority ? 'blue' : 'gray' }"
            style="color: blue"
          ></i>
        </div>
        <div class="col-xl-2 text-truncate">
          {{ item?.type?.label || item?.type?.value?.label }}
        </div>

        <div class="col-xl-6 text-truncate">
          {{ item?.email }}
        </div>
        <div class="col-xl-3 text-end" *ngIf="!isReadOnly">

        <button
            type="button"
            class="btn btn-sm btn-warning btn-icon-xxs me-1"
            (click)="edit(item, i)"
          >
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-danger btn-icon-xxs"
            (click)="deleteItem(i)"
          >
            <i class="fas fa-trash-alt"></i>
          </button>
        </div>
      </div>
      <div class="row"></div>
    </div>

    <ng-template class="card p-3" #editingRow>
      <div class="card p-3 mb-2">
        <div class="row align-items-center mb-2">
          <div class="col-xl-3">
            <p-dropdown
              [options]="types"
              [placeholder]="'shared-components.type' | translate"
              [(ngModel)]="selectedRow.type"
              optionLabel="label"
              appendTo="body"
            >
            </p-dropdown>
          </div>

          <div class="col-xl-5">
            <input
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="selectedRow.email"
              placeholder="{{ 'shared-components.email-plc' | translate }}"
            />
          </div>
          <div class="col-xl-1">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              [(ngModel)]="selectedRow.priority"
              aria-checked="true"
            />
          </div>
          <div class="col-xl-3">
            <div class="float-right">
              <button
                type="button"
                class="btn btn-sm btn-warning btn-icon-xxs me-1"
                (click)="saveItem()"
                [disabled]="!isValidEmail(selectedRow.email)"
              >
                <i class="fas fa-save"></i>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-danger btn-icon-xxs"
                (click)="cancel()"
              >
                <i class="fas fa-close"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
